import { render } from "./BaseButtonPurple.vue?vue&type=template&id=42aac00a"
const script = {}
script.render = render

export default script